import { logEvent } from '@_shared/config';

import type { LogParameters } from '../types';
import { useLogParams } from './useLogParams';

interface LoggerParams {
	params: LogParameters;
	component?: string;
}

export const useLogger = () => {
	const parentParams = useLogParams();

	const log = ({ params }: LoggerParams) => {
		logEvent(`log`, {
			...params,
			...parentParams,
		});
	};

	const screen = ({ params }: LoggerParams) => {
		logEvent(`screen`, {
			...params,
			...parentParams,
		});
	};

	const click = ({ params }: LoggerParams) => {
		logEvent(`click`, {
			...params,
			...parentParams,
		});
	};

	const popup = ({ params }: LoggerParams) => {
		logEvent(`popup`, {
			...params,
			...parentParams,
		});
	};

	return { log, screen, click, popup };
	// return { log, screen, click };
};
